export const videoTagsKeys = {
  all: () => ['video-tags'] as const,
  video: (videoId: number) => [...videoTagsKeys.all(), videoId] as const,
};
